<app-page-heading [key]="'user-dashboard.carriers.list.page-title'"></app-page-heading>

<section class="container-fluid summary-panel">

    <app-data-table [columns]="columns"
                    [sortColumn]="sortColumn"
                    [direction]="direction"
                    [loadPage]="loadPage"
                    [(filters)]="filters"
                    [filtersComponent]="dataFilters"
                    (onLoad)="pageLoaded($event)"
                    [noOverflow]="true">

        <app-data-filters #dataFilters>
            <app-data-filter-group>
                <app-data-filter-input [labelKey]="'user-dashboard.carriers.list.filters.name.label'"
                                       [(model)]="filters.name"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'user-dashboard.carriers.list.filters.code.label'"
                                       [(model)]="filters.code"></app-data-filter-input>

                <app-data-filter-select [labelKey]="'user-dashboard.carriers.list.filters.region.label'"
                                        [(model)]="filters.region_id"
                                        [options]="regionsOptions"
                                        [useOptionLabel]="true"></app-data-filter-select>

                <app-data-filter-input [labelKey]="'user-dashboard.carriers.list.filters.sap-vendor.label'"
                                       [(model)]="filters.sap_vendor"></app-data-filter-input>
                <app-data-filter-input [labelKey]="'user-dashboard.carriers.list.filters.sap-scac.label'"
                                       [(model)]="filters.sap_scac"></app-data-filter-input>
                <app-data-filter-input [labelKey]="'user-dashboard.carriers.list.filters.by-carrier-code.label'"
                                       [(model)]="filters.by_carrier_code"></app-data-filter-input>

                <app-data-filter-select [labelKey]="'user-dashboard.carriers.list.filters.tms-type.label'"
                                        [(model)]="filters.tms_type"
                                        [options]="tmsTypeOptions"></app-data-filter-select>
            </app-data-filter-group>
        </app-data-filters>

        <app-data-buttons>
            <button class="btn btn-primary btn-lg pull-right m-r-sm" (click)="goToCreateCarrier()">
                <span class="fa fa-plus"></span> <span [i18n]="'user-dashboard.carriers.list.buttons.create'"></span>
            </button>
            <button class="btn btn-primary btn-lg pull-right m-r-sm" [type]="'primary'" (click)="exportCarriers()">
                <i class="fa fa-download"></i> <span [i18n]="'user-dashboard.carriers.list.buttons.export'"></span>
            </button>
        </app-data-buttons>

        <ng-container subBar>
            <button class="btn btn-primary btn-lg m-b-md" [disabled]="!bluechatEnabled || selectedCarriers().length === 0" (click)="openMultipleBluechatModal()">
                <span [i18n]="'user-dashboard.carriers.list.buttons.enable-bluechat'"></span>
            </button>
        </ng-container>
    </app-data-table>
</section>

<ng-template #checkboxColumn let-carrier="item">
    <div *ngIf="carrier.eligibleToBluechatActivation">
        <div class="checkbox">
            <label>
                <input type="checkbox" [(ngModel)]="carrier.selected">
                <i class="fa checkbox-icon"></i>
            </label>
        </div>
    </div>
</ng-template>

<ng-template #nameColumn let-name="name">
    {{ name }}
</ng-template>

<ng-template #codeColumn let-code="code">
    {{ code }}
</ng-template>

<ng-template #tmsColumn let-tmsType="tmsType" let-blujayUrlLabel="blujayUrlLabel" let-blueyonderCarrierCode="blueyonderCarrierCode">
    <span *ngIf="tmsType === 'BLUJAY'" > <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.blujay'}]"></span> - {{ blujayUrlLabel }} </span>
    <span *ngIf="tmsType === 'BLUEYONDER'" > <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.blueyonder'}]"></span> - {{ blueyonderCarrierCode }} </span>
    <span *ngIf="tmsType !== 'BLUEYONDER' && tmsType !== 'BLUJAY'" > / </span>
</ng-template>

<ng-template #lastTmsSynchronizationColumn let-lastTmsSynchronization="lastTmsSynchronization">
    <span title="{{lastTmsSynchronization | formatDate : 'YYYY-MM-DD HH:mm'}}"> {{ lastTmsSynchronization | dateDiffFromNow | async }}</span>
</ng-template>

<ng-template #regionColumn let-region="region">
    <a class="cmaweb-link" *ngIf="canManageRegions" [href]="link.goToRegion(region.name)" target="_blank">{{ region.name }}</a>
    <span *ngIf="!canManageRegions">{{region.name}}</span>
</ng-template>

<ng-template #statusColumn let-blocked="blocked">
    <span *ngIf="!blocked" class="fa fa-unlock text-success" [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.not-blocked'}]"></span>
    <span *ngIf="blocked" class="fa fa-lock text-danger" [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.blocked'}]"></span>
</ng-template>

<ng-template #bluechatColumn let-carrier="item">
    <button class="btn btn-i btn-outline-secondary btn-sm pull-right"
            (click)="openEnableBluechatModal(carrier)"
            *ngIf="carrier.bluechatCarrierCode === null && carrier.isUsingBlueyonderTms"
            [disabled]="!bluechatEnabled">
        <span><i class="fas fa-comment"></i><span [i18n]="'bluechat.activate'"></span></span>
    </button>
    <div class="status status-activate" *ngIf="carrier.bluechatCarrierCode != null && carrier.isUsingBlueyonderTms">
        <span><i class="fa fa-check"></i><span [i18n]="'bluechat.activated'"></span></span>
    </div>
    <div *ngIf="!carrier.isUsingBlueyonderTms">
        <span><span [i18n]="'bluechat.not-available'"></span></span>
    </div>
</ng-template>

<ng-template #blueChatCarriersModalTemplate>

    <span [i18n]="'bluechat.carriers-activation-modal.label'"></span>
    <div class="checkbox">
        <label>
            <input type="checkbox" [(ngModel)]="modalMultipleBluechatActivateAllAgents">
            <i class="fa checkbox-icon"></i>
            <span [i18n]="'bluechat.carriers-activation-modal.checkbox-label'"></span>
        </label>
    </div>

</ng-template>

<ng-template #blueChatModalTemplate let-users="users">
    <div class="alert alert-info small blueChatCode">
        <div class="row text-center" style="width: 100%">
            <div class="col-xs-12">
                <i class="fa fa-info-circle m-r-xs"></i>
                <span [i18n]="'bluechat.modal.carrier.existing-carrier-label'"></span><br>
            </div>
            <div class="col-xs-12">
                <div class="row">
                    <div class="col-xs-2"></div>
                    <div class="col-xs-8 alignLabelCode">
                        <span [i18n]="'bluechat.modal.carrier.code-input-label'"></span>
                        <input class="form-control" [(ngModel)]="modalBluechatCode">
                    </div>
                    <div class="col-xs-2"></div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <span class="m-b-md" [i18n]="'bluechat.modal.carrier.user-select'"></span>

        <ng-select [multiple]="true"
                   [bindLabel]="'email'"
                   [items]="users"
                   [(ngModel)]="modalBluechatSelectedCarrierManagers">
        </ng-select>
    </div>
</ng-template>

<ng-template #actionsColumn let-blocked="blocked" let-id="id" let-isUsingLocalLoads="isUsingLocalLoads" let-isUsingBlujayTms="isUsingBlujayTms" let-isUsingBlueyonderTms="isUsingBlueyonderTms" let-bluechatCarrierCode="bluechatCarrierCode">
    <!-- <button class="btn btn-success btn-sm m-r-xs" [disabled]="blocked" (click)="goToCreateManager(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.add-manager.tooltip'}]">
        <span class="fa fa-plus"></span>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.add-manager.label'}]"></span>
    </button>
    <button class="btn btn-info btn-sm m-r-xs" (click)="goToManagers(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.view-managers.tooltip'}]">
        <span class="fa fa-eye"></span>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.view-managers.label'}]"></span>
    </button>
    <button class="btn btn-success btn-sm m-r-xs" [disabled]="blocked" (click)="goToCreateDriver(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.add-driver.tooltip'}]">
        <span class="fa fa-plus"></span>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.add-driver.label'}]"></span>
    </button>
    <button class="btn btn-info btn-sm m-r-xs" (click)="goToDrivers(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.view-drivers.tooltip'}]">
        <span class="fa fa-eye"></span>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.view-drivers.label'}]"></span>
    </button>
    <button class="btn btn-success btn-sm m-r-xs" [disabled]="blocked" (click)="goToCreateSubcontractor(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.add-subcontractor.tooltip'}]">
        <span class="fa fa-plus"></span>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.add-subcontractor.label'}]"></span>
    </button>
    <button class="btn btn-info btn-sm m-r-xs" (click)="goToSubcontractors(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.view-subcontractors.tooltip'}]">
        <span class="fa fa-eye"></span>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.view-subcontractors.label'}]"></span>
    </button>
    <button class="btn btn-sm m-r-xs" (click)="goToEditCarrier(id)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.edit-carrier.tooltip'}]">
        <i class="fa fa-edit"></i>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.edit-carrier.label'}]"></span>
    </button>
    <button class="btn btn-white btn-sm m-r-xs" (click)="goToTmsSynchronization(id)" *ngIf="isUsingLocalLoads && (isUsingBlujayTms || isUsingBlueyonderTms)"
            [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.tms-synchronization.tooltip'}]">
        <i class="fa fa-refresh"></i>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.tms-synchronization.label'}]"></span>
    </button>-->
    <dropdown-actions>
        <div class="dropdown-item">
            <button class="btn btn-success btn-sm m-r-xs" [disabled]="blocked" (click)="goToCreateManager(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.add-manager.tooltip'}]">
                <span class="fa fa-plus"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.add-manager.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-info btn-sm m-r-xs" (click)="goToManagers(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.view-managers.tooltip'}]">
                <span class="fa fa-eye"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.view-managers.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-success btn-sm m-r-xs" [disabled]="blocked" (click)="goToCreateDriver(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.add-driver.tooltip'}]">
                <span class="fa fa-plus"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.add-driver.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-info btn-sm m-r-xs" (click)="goToDrivers(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.view-drivers.tooltip'}]">
                <span class="fa fa-eye"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.view-drivers.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-success btn-sm m-r-xs" [disabled]="blocked" (click)="goToCreateSubcontractor(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.add-subcontractor.tooltip'}]">
                <span class="fa fa-plus"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.add-subcontractor.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-info btn-sm m-r-xs" (click)="goToSubcontractors(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.view-subcontractors.tooltip'}]">
                <span class="fa fa-eye"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.view-subcontractors.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-sm m-r-xs" (click)="goToEditCarrier(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.edit-carrier.tooltip'}]">
                <i class="fa fa-edit"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.edit-carrier.label'}]"></span>
            </button>
        </div>
        <div class="dropdown-item" *ngIf="isUsingLocalLoads && (isUsingBlujayTms || isUsingBlueyonderTms)">
            <button class="btn btn-white btn-sm m-r-xs" (click)="goToTmsSynchronization(id)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.carriers.list.table.actions.tms-synchronization.tooltip'}]">
                <i class="fa fa-refresh"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.carriers.list.table.actions.tms-synchronization.label'}]"></span>
            </button>
        </div>
    </dropdown-actions>
</ng-template>
